import record from './record'
import selectiveCoursePlay from './selectivecourseplay'
import playback from './playback'

const videoPlay = {
  path: 'videoPlay/:courseId',
  component: resolve => require(['../../../pages/user/videoplay'], resolve),
  children: [
    record,
    selectiveCoursePlay,
    playback
  ]
}

export default videoPlay



// WEBPACK FOOTER //
// ./src/router/user/videoplay/index.js